import React, { useRef, useState, useEffect } from "react";
import { mediaQueryHOC } from "../../../adapters/helpers/Hooks";
import Block from "../../../adapters/helpers/Block";
import Image from "../../Image/Image";
import { StartGuideBlockConstants } from "../../../adapters/helpers/Constants";
import ResponsiveImage from "../../ResponsiveImage/ResponsiveImage";
import Slider from "react-slick";
import { AnalyticsConstants } from "../../../adapters/helpers/ConstantsGA";
import {addRemainder} from "../../../adapters/helpers/Utils"
import { sanitize } from 'isomorphic-dompurify'

const StartGuideShuffleBlock = (props) => {
  const block = new Block(props);
  const className = block.getFieldValue(StartGuideBlockConstants.className);
  const cards = block.getFieldValue(StartGuideBlockConstants.cards);
  const desktopBackgroundAsset = block.getFieldValue(
    StartGuideBlockConstants.backgroundAsset
  );
  const mobileBackgroundAsset = block.getFieldValue(
    StartGuideBlockConstants.mobileBackgroundAsset
  );
  const isVerticalCarousel = block.getFieldValue(
    StartGuideBlockConstants.isVerticalCarousel
  );
  const carouselBackground = block.getFieldValue(
    StartGuideBlockConstants.carouselBackground
  );
  const carouselForeground = block.getFieldValue(
    StartGuideBlockConstants.carouselForeground
  );
  const carouselItems = block.getFieldValue(
    StartGuideBlockConstants.carouselItems
  );
  const isAnimationCards = block.getFieldValue(
    StartGuideBlockConstants.isAnimationCards
  );
  const [showRemainderClasses, setShowRemainderClasses] = useState(false);
  const anchorId = block.getFieldValue(StartGuideBlockConstants.anchorId);
  const [sliderIndex, setSliderIndex] = useState(1);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const { isXSmall, isSmall, isMedium, isXLarge, languageCode } = props;
  const sliderRef = useRef();
  const imageRefAnimation = useRef(null);

  const carouselSettings = {
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: false,
    autoplay: false,
    dots: false,
    vertical: true,
    draggable: false,
    centerMode: true,
  };
  const mobileCarouselSettings = {
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: false,
    autoplay: false,
    dots: false,
    draggable: true,
    centerMode: true,
    centerPadding: "50px",
  };

  const isDivInViewPort = (element, addition) => {
    const ele = document.querySelector(element);
    if (!ele) {
      return false;
    }
    const rect = ele.getBoundingClientRect();
    const viewPortHeight = window.innerHeight;
    return rect.top + addition < viewPortHeight && rect.bottom > 0;
  };

  /**
   * For scrolling animation for iO2 Page
   */
  useEffect(() => {
    let viewPortValue = 0;
    let viewPortRatio = 800;
    let targetEle = null;
    const handleScrollAnimation = () => {
      targetEle = isDivInViewPort(
        "#start-guide-shuffle-block-second",
        viewPortValue
      );
      if (targetEle) {
        const ele = document.getElementById("start-guide-shuffle-block-second");
        const secEle = ele.getBoundingClientRect();
        const viewPortHeight = window.innerHeight;
        const visibleHeight =
          secEle.height > viewPortHeight ? viewPortHeight : secEle.height;
        const intersectionRatio = visibleHeight - Math.max(0, secEle.top);
        if (imageRefAnimation && imageRefAnimation.current) {
          imageRefAnimation.current.style.visibility =
            intersectionRatio >= viewPortRatio ? "hidden" : "visible";
          imageRefAnimation.current.style.transform = `translateY(${intersectionRatio}px)`;
        }
      }
    };
    window.addEventListener("scroll", handleScrollAnimation);
    return () => window.removeEventListener("scroll", handleScrollAnimation);
  }, []);

  useEffect(() => {
    const addScrollClass = (secondBlock, blockElem, classNam) => {
      var windowHeight = window.innerHeight;
      var elementTop = secondBlock.getBoundingClientRect().top;
      var elementVisible = 50;

      if (elementTop < windowHeight - elementVisible) {
        blockElem.classList.add(classNam);
      } else {
        blockElem.classList.remove(classNam);
      }
    };

    const srollContent = () => {
      var rightPressureStepImg = document.querySelector(
        ".use-right-pressure .start-guide-animation-asset"
      );
      var rightPressureStep = document.querySelector(
        ".use-right-pressure .start-guide-text-content"
      );

      addScrollClass(
        rightPressureStepImg,
        rightPressureStep,
        "activeAnimReplacing"
      );
    };
    window.addEventListener("scroll", srollContent);
  }, []);

  const checkIsMobile = () => {
    return isXSmall || isSmall ? true : false;
  };

  const handleSliderButtonClick = () => {
    sliderRef.current.slickNext();
  };

  const handleCarouselItemClick = (clickedIndex) => {
    if (clickedIndex === currentSlideIndex) {
      sliderRef.current.slickNext();
    } else if (clickedIndex > currentSlideIndex) {
      sliderRef.current.slickNext();
    } else {
      sliderRef.current.slickPrev();
    }
  };

  const addRemainderClass = () => {
    setShowRemainderClasses(!showRemainderClasses);
  };

  useEffect(() => {
    if (sliderRef.current) {
      setCurrentSlideIndex(sliderRef.current.innerSlider.state.currentSlide);
    }
  }, [currentSlideIndex]);

  const renderTextContent = (option) => {
    return (
      <div className="start-guide-text-container">
        {option.secondaryImage && (

          <div className="start-guide-secondary-image">
            <img src={option.secondaryImage.fields.asset.fields.file.url} alt="secondary-image"/>
          </div>
        )}
        <div className="start-guide-text-content">
          <h2
            className="start-guide-header"
            dangerouslySetInnerHTML={{ __html: sanitize(option.title) }}
          />
          <p
            className="start-guide-subtext"
            dangerouslySetInnerHTML={{ __html: sanitize(option.description) }}
          />
          {option.ctaLabel &&
            (option.ctaMode == "calender" ? (
              <a
                className={`${option?.ctaCustomEventClass} start-guide-cta-link`}
                target={"_blank"}
                rel="noopener noreferrer"
                onClick={addRemainderClass}
                data-action-detail={option?.ctaLabel}
                aria-label={option?.ctaLabel}
              >
                <p>{option.ctaLabel}</p>
              </a>
            ) : (
              <a
                className={`${option?.ctaCustomEventClass} start-guide-cta-link`}
                href={`${option.ctaLink}`}
                target={"_blank"}
                rel="noopener noreferrer"
                data-action-detail={option?.ctaLabel}
                aria-label={option?.ctaLabel}
              >
                <p>{option.ctaLabel}</p>
              </a>
            ))}
          {option?.remainderCalender && (
            <div className="select-calender">
              <div
                className={`calender-option-list-section ${
                  showRemainderClasses ? "d-block" : "d-none"
                }`}
              >
                <div
                  class="calendar-close-button"
                  onClick={addRemainderClass}
                />
                <p class="calender-title">
                  {option?.remainderCalender?.fields?.remainderListTitle}
                </p>

                {option?.remainderCalender?.fields?.remainderList.map(
                  (cardOption) => {
                    return (
                      <div
                        class={`${cardOption?.fields?.ctaCustomEventClass} calender-content`}
                        onClick={() =>
                          addRemainder(
                            option?.remainderCalender?.fields,
                            cardOption?.fields
                          )
                        }
                        data-action-detail={`${cardOption?.fields?.type} ${AnalyticsConstants.calender}`}
                      >
                        <span class="calender-img">
                          <Image image={cardOption?.fields?.icon} />
                        </span>
                        <span class="calender-option-list">
                          {cardOption?.fields?.type}
                        </span>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          )}
          {isVerticalCarousel && checkIsMobile() && (
            <div className="slider-container">
              <Slider
                ref={sliderRef}
                {...mobileCarouselSettings}
                beforeChange={(current, next) => {
                  const corouselLngth = carouselItems.length;
                  setCurrentSlideIndex(next);
                  setSliderIndex(next + 1 == corouselLngth ? 0 : next + 1);
                }}
              >
                {carouselItems.map((item) => {
                  return (
                    <div className="carousel-item">
                      <Image image={item?.fields?.icons} />
                      <div className="carousel-item-text">
                        <p className="text-header">{item?.fields?.title}</p>
                        <p className="text-description">
                          {item?.fields?.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}
          {option.video ? (
            <>
              {new Block(option.video).renderBlockFromDocument(option.video)}{" "}
              <h3
                className="videoDescription"
                dangerouslySetInnerHTML={{ __html: sanitize(option?.videoDescription) }}
              />
            </>
          ) : (
            option.videoThumbnail && (
              <div className="ob-carousel-tab-content-conatiner-image">
                <ResponsiveImage
                  document={option.videoThumbnail}
                ></ResponsiveImage>
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  const renderImageContent = (option) => {
    return (
      <div>
        {checkIsMobile() ? (
          <>
            {isVerticalCarousel && (
              <div className="vertical-carousel-container">
                <Image className={"bg-img"} image={carouselBackground}>
                  <button
                    onClick={() => handleSliderButtonClick()}
                    className="event_button_click"
                    data-action-detail={`${carouselItems[sliderIndex]?.fields?.title}`}
                  >
                    <Image
                      className={"fg-img vertical-carousel-button"}
                      image={carouselForeground}
                    >
                      <p>{StartGuideBlockConstants.cycleSettingsButton}</p>
                    </Image>
                  </button>
                </Image>
              </div>
            )}
            {!isVerticalCarousel && (
              <Image
                className={"start-guide-animation-asset"}
                image={option.mobileAnimationAsset}
              />
            )}
          </>
        ) : (
          <>
            {isVerticalCarousel && (
              <div className="vertical-carousel-container">
                <Image className={"bg-img"} image={carouselBackground}>
                  <button
                    onClick={() => handleSliderButtonClick()}
                    className="event_button_click"
                    data-action-detail={`${carouselItems[sliderIndex]?.fields?.title}`}
                  >
                    <Image
                      className={"fg-img vertical-carousel-button"}
                      image={carouselForeground}
                    >
                      <p>{StartGuideBlockConstants.cycleSettingsButton}</p>
                    </Image>
                  </button>
                </Image>
                <div className="slider-container">
                  <Slider
                    ref={sliderRef}
                    {...carouselSettings}
                    beforeChange={(current, next) => {
                      const corouselLngth = carouselItems.length;
                      setCurrentSlideIndex(next);
                      setSliderIndex(next + 1 == corouselLngth ? 0 : next + 1);
                    }}
                  >
                    {carouselItems.map((item, index) => {
                      return (
                        <div
                          className="carousel-item"
                          item-index={currentSlideIndex}
                          onClick={() => handleCarouselItemClick(index)}
                        >
                          <Image image={item?.fields?.icons} />
                          <div className="carousel-item-text">
                            <p className="text-header">{item?.fields?.title}</p>
                            <p className="text-description">
                              {item?.fields?.description}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}
            {!isVerticalCarousel && (
              <Image
                className={"start-guide-animation-asset"}
                image={option.animationAsset}
              />
            )}
          </>
        )}
      </div>
    );
  };

  const renderShuffleBlock = (option) => {
    const contentOrder = option.animationImagePosition === 'Left' ? [renderImageContent, renderTextContent] : [renderTextContent, renderImageContent];
    return (
      <>
        {contentOrder.map(renderFuntion => renderFuntion(option))};
      </>
    )
  };

  const renderMobileLayout = (option) => {
    return (
      <div className={`start-guide-shuffle-block ${option.className}`}>
        <Image
          className={"start-guide-background"}
          image={mobileBackgroundAsset}
        />
        <div className={"start-guide-content-container"}>
          {renderShuffleBlock(option)}
        </div>
      </div>
    );
  };

  const renderDesktopLayout = (option) => {
    return (
      <div className={`start-guide-shuffle-block ${option.className}`}>
        <Image
          className={"start-guide-background"}
          image={desktopBackgroundAsset}
        />
        <div className={"start-guide-content-container"}>
          {renderShuffleBlock(option)}
        </div>
      </div>
    );
  };

  // Animation Blocks
  const renderAnimationLayout = () => {
    return (
      <>
        {cards && cards?.[0] && (
          <div
            className={`start-guide-shuffle-block ${cards?.[0]?.fields.className}`}
          >
            <Image
              className={"start-guide-background"}
              image={
                checkIsMobile() ? mobileBackgroundAsset : desktopBackgroundAsset
              }
            />

            <div
              className={"start-guide-content-container"}
              id="start-guide-content-container-first"
            >
              {cards?.[0]?.fields.animationImagePosition ===
                StartGuideBlockConstants.left && (
                <div>
                  {checkIsMobile() ? (
                    <div className="ob-mainAsset-wrapper start-guide-animation-asset">
                      <img
                        className="ob-mainAsset-wrapper-img"
                        src={
                          cards?.[0]?.fields.mobileAnimationAsset?.fields
                            ?.assetId
                        }
                      />
                    </div>
                  ) : (
                    <Image
                      className={"start-guide-animation-asset"}
                      image={cards?.[0]?.fields.animationAsset}
                    />
                  )}
                </div>
              )}

              {renderTextContent(cards?.[0]?.fields)}

              {cards?.[0]?.fields.animationImagePosition ===
                StartGuideBlockConstants.right && (
                <div
                  className="ob-contentBlock-text-image"
                  ref={imageRefAnimation}
                >
                  {checkIsMobile() ? (
                    <div className="ob-mainAsset-wrapper start-guide-animation-asset first-animation">
                      <img
                        className="ob-mainAsset-wrapper-img"
                        src={
                          cards?.[0]?.fields.mobileAnimationAsset?.fields
                            ?.assetId
                        }
                        alt={
                          cards?.[0]?.fields.mobileAnimationAsset?.fields
                            ?.alternateText
                        }
                      />
                    </div>
                  ) : (
                    <Image
                      className={"start-guide-animation-asset first-animation"}
                      image={cards?.[0]?.fields.animationAsset}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <div>
          {cards && cards?.[1] && (
            <div
              className={`start-guide-shuffle-block ${cards?.[1]?.fields.className}`}
              id="start-guide-shuffle-block-second"
            >
              <Image
                className={"start-guide-background"}
                image={
                  checkIsMobile()
                    ? mobileBackgroundAsset
                    : desktopBackgroundAsset
                }
              />

              <div className={"start-guide-content-container"}>
                {cards?.[1]?.fields.animationImagePosition ===
                  StartGuideBlockConstants.left && (
                  <div id="start-guide-shuffle-block-img-second">
                    {checkIsMobile() ? (
                      <div className="ob-mainAsset-wrapper start-guide-animation-asset">
                        <img
                          className="ob-mainAsset-wrapper-img"
                          src={
                            cards?.[1]?.fields.mobileAnimationAsset?.fields
                              ?.assetId
                          }
                          alt={
                            cards?.[1]?.fields.mobileAnimationAsset?.fields
                              ?.alternateText
                          }
                        />
                      </div>
                    ) : (
                      <Image
                        className={"start-guide-animation-asset"}
                        image={cards?.[1]?.fields.animationAsset}
                      />
                    )}
                  </div>
                )}

                <div id={"start-guide-shuffle-block-second-txt"}>
                  {renderTextContent(cards?.[1]?.fields)}

                  {cards?.[1]?.fields.animationImagePosition ===
                    StartGuideBlockConstants.right && (
                    <div>
                      {checkIsMobile() ? (
                        <div className="ob-mainAsset-wrapper start-guide-animation-asset">
                          <img
                            className="ob-mainAsset-wrapper-img"
                            src={
                              cards?.[1]?.fields.mobileAnimationAsset?.fields
                                ?.assetId
                            }
                            alt={
                              cards?.[1]?.fields.mobileAnimationAsset?.fields
                                ?.alternateText
                            }
                          />
                        </div>
                      ) : (
                        <Image
                          className={"start-guide-animation-asset"}
                          image={cards?.[1]?.fields.animationAsset}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div>
          {cards && cards?.[2] && (
            <div
              className={`start-guide-shuffle-block ${cards?.[2]?.fields.className}`}
              id="start-guide-shuffle-block-third"
            >
              <Image
                className={"start-guide-background"}
                image={
                  checkIsMobile()
                    ? mobileBackgroundAsset
                    : desktopBackgroundAsset
                }
              />

              <div className={"start-guide-content-container"}>
                {cards?.[2]?.fields.animationImagePosition ===
                  StartGuideBlockConstants.left && (
                  <div id="start-guide-shuffle-block-img-second">
                    {checkIsMobile() ? (
                      <div className="ob-mainAsset-wrapper start-guide-animation-asset">
                        <img
                          className="ob-mainAsset-wrapper-img"
                          src={
                            cards?.[1]?.fields.mobileAnimationAsset?.fields
                              ?.assetId
                          }
                          alt={
                            cards?.[1]?.fields.mobileAnimationAsset?.fields
                              ?.alternateText
                          }
                        />
                      </div>
                    ) : (
                      <Image
                        className={"start-guide-animation-asset"}
                        image={cards?.[1]?.fields.animationAsset}
                      />
                    )}
                  </div>
                )}

                {
                  <div
                    className={`${cards?.[2]?.fields.className}`}
                    id="start-guide-shuffle-block-third-txt"
                  >
                    {renderTextContent(cards?.[2]?.fields)}

                    {cards?.[2]?.fields.animationImagePosition ===
                      StartGuideBlockConstants.right && (
                      <div>
                        {checkIsMobile() ? (
                          <div className="ob-mainAsset-wrapper start-guide-animation-asset">
                            <img
                              className="ob-mainAsset-wrapper-img"
                              src={
                                cards?.[1]?.fields.mobileAnimationAsset?.fields
                                  ?.assetId
                              }
                              alt={
                                cards?.[1]?.fields.mobileAnimationAsset?.fields
                                  ?.alternateText
                              }
                            />
                          </div>
                        ) : (
                          <Image
                            className={"start-guide-animation-asset"}
                            image={cards?.[2]?.fields.animationAsset}
                          />
                        )}
                      </div>
                    )}
                  </div>
                }
              </div>
            </div>
          )}
        </div>
      </>
    );
  };

  // Animation Block Ends Here
  return (
    <div className={className ? className : null} id={anchorId ? anchorId : ""}>
      {!isAnimationCards ? (
        <>
          {cards &&
            cards.map((cardOption, index) => {
              const option = cardOption?.fields;
              return checkIsMobile()
                ? renderMobileLayout(option)
                : renderDesktopLayout(option);
            })}
        </>
      ) : (
        <>{cards && <>{renderAnimationLayout()}</>}</>
      )}
    </div>
  );
};

export default mediaQueryHOC(StartGuideShuffleBlock);
